import { useEffect } from "react";
import { LANGS } from "../context/LanguageContext";
import { SITE_URL } from "../constants/site";

export function useSeo(title, description, jsonLd) {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);

    const origin = SITE_URL;
    const path = window.location.pathname;
    const parts = path.split("/").filter(Boolean);
    if (parts.length && LANGS.includes(parts[0])) parts.shift();
    const clean = "/" + parts.join("/");

    let canon = document.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.setAttribute("rel", "canonical");
      document.head.appendChild(canon);
    }
    canon.setAttribute("href", origin + path);

    document.querySelectorAll('link[rel="alternate"][hreflang]').forEach((l) => l.remove());
    const altFor = (code) => origin + (code === "en" ? clean : `/${code}${clean === "/" ? "" : clean}`);
    [...LANGS, "x-default"].forEach((code) => {
      const l = document.createElement("link");
      l.setAttribute("rel", "alternate");
      l.setAttribute("hreflang", code);
      l.setAttribute("href", code === "x-default" ? origin + clean : altFor(code));
      document.head.appendChild(l);
    });

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "route-jsonld";
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      if (script) script.remove();
    };
  }, [title, description]);
}
